import type { CSSProperties } from 'react';

interface Star {
  x: string;
  y: string;
  delay: string;
  duration: string;
  size: number;
  extra?: boolean;
}

const STARS: Star[] = Array.from({ length: 18 }, (_, index) => ({
  x: `${(index * 47 + 13) % 94}%`,
  y: `${(index * 31 + 9) % 88}%`,
  delay: `-${(index % 7) * 0.43}s`,
  duration: `${2.2 + (index % 5) * 0.55}s`,
  size: index % 4 === 0 ? 1.35 : 0.7 + (index % 3) * 0.2,
  extra: index >= 9,
}));

const VEINS = [
  'M0 8 C5 10 9 14 13 16 C17 18 19 22 21 26',
  'M13 16 C12 21 8 24 5 29',
  'M100 12 C94 14 90 18 86 20 C82 22 81 27 79 31',
  'M86 20 C89 25 93 27 96 32',
  'M0 64 C5 63 9 66 13 70 C17 74 19 76 22 80',
  'M13 70 C11 76 7 80 5 88',
  'M100 70 C95 69 91 72 87 76 C83 80 80 82 78 88',
  'M91 72 C94 77 97 79 100 84',
  'M30 0 C31 3 28 6 29 9',
  'M72 0 C71 3 74 6 73 9',
  'M0 40 C4 42 5 46 4 51',
  'M100 46 C96 48 94 52 96 57',
];

const VEIN_NODES = [
  [13, 16],
  [86, 20],
  [13, 70],
  [87, 76],
  [4, 46],
  [96, 52],
];

export function SenitaFx({ motes, rich }: { motes: boolean; rich: boolean }) {
  return (
    <span className="fx fx--senita" aria-hidden="true">
      <span className="fx__senita-cloud fx__senita-cloud--violet" />
      <span className="fx__senita-flesh" />
      {motes && (
        <svg className="fx__senita-veins" viewBox="0 0 100 100" preserveAspectRatio="none">
          <g className="fx__senita-vein-base">
            {VEINS.map((d) => (
              <path key={d} d={d} />
            ))}
          </g>
          <g className="fx__senita-vein-pulse">
            {VEINS.map((d, index) => (
              <path key={d} d={d} pathLength={1} style={{ animationDelay: `${-(index % 5) * 0.32}s` }} />
            ))}
          </g>
          {VEIN_NODES.map(([cx, cy], index) => (
            <circle key={index} cx={cx} cy={cy} r="1.2" style={{ animationDelay: `${-index * 0.27}s` }} />
          ))}
        </svg>
      )}
      {rich && <span className="fx__senita-cloud fx__senita-cloud--gold" />}
      {motes && (
        <span className="fx__senita-stars">
          {STARS.map((star, index) => (
            <i
              key={index}
              className={star.extra ? 'is-extra' : undefined}
              style={
                {
                  '--x': star.x,
                  '--y': star.y,
                  '--delay': star.delay,
                  '--time': star.duration,
                  '--s': star.size,
                } as CSSProperties
              }
            />
          ))}
        </span>
      )}
      <span className="fx__senita-corona" />
      <span className="fx__vignette" />
    </span>
  );
}